<div *ngIf="item$ | async as item" class="flex flex-col gap-4">
  <ng-container *vsLet="claim$ | async as claim">
    <ws-claim-item-details-card class="border rounded-xl" [claim]="claim" [item]="item"></ws-claim-item-details-card>

    <!-- Charges, holds and escalations are part of the new claims flow -->
    <ng-container *ngIf="!claim || usesNewFlow(claim)">
      <ws-claim-item-lines-table
        #linesTable
        [claim]="claim"
        [item]="item"
        [canManage]="
          !!(canManageCoverage$ | async) &&
          claim?.status === open &&
          !item.authorizationId &&
          item.status === draft &&
          !item.deleted
        "
        [canAdjust]="
          !!(canAdjust$ | async) &&
          claim?.status === open &&
          !item.authorizationId &&
          item.status === draft &&
          !item.deleted
        "
        [canViewHistory]="(isCustomerPortal$ | async) !== true"
        (linesChanged)="refreshHolds()"
      ></ws-claim-item-lines-table>

      <ws-claim-item-holds
        *ngIf="(isCustomerPortal$ | async) !== true"
        [claim]="claim"
        [item]="item"
        [lines]="(linesTable.lines$ | async) ?? []"
        [canManage]="
          !!(canManageHolds$ | async) &&
          claim?.status === open &&
          !item.authorizationId &&
          item.status !== resolved &&
          !item.deleted
        "
        [canClose]="!!(canManageHolds$ | async) && claim?.status === open && !item.authorizationId && !item.deleted"
        [canViewFiles]="!!(canViewFiles$ | async)"
        [canUploadFiles]="!!(canUploadFiles$ | async)"
        [canAttachEvidence]="
          !!(canAttachEvidence$ | async) && claim?.status === open && !item.authorizationId && !item.deleted
        "
        (changed)="linesTable.refresh()"
      ></ws-claim-item-holds>
    </ng-container>

    <!-- Holds opened before a claim kept the previous flow can still be closed; no new ones -->
    <ws-claim-item-holds
      *ngIf="claim && !usesNewFlow(claim) && (isCustomerPortal$ | async) !== true"
      #previousFlowHolds
      [class.hidden]="!(previousFlowHolds.holds$ | async)?.length && !(previousFlowHolds.escalations$ | async)?.length"
      [claim]="claim"
      [item]="item"
      [canClose]="!!(canManageHolds$ | async) && claim.status === open && !item.authorizationId && !item.deleted"
      [canViewFiles]="!!(canViewFiles$ | async)"
      [canUploadFiles]="!!(canUploadFiles$ | async)"
      [canAttachEvidence]="
        !!(canAttachEvidence$ | async) && claim.status === open && !item.authorizationId && !item.deleted
      "
    ></ws-claim-item-holds>

    <div class="flex gap-2 flex-wrap">
      <vs-info-card
        *ngFor="let linkAndConfig of linksAndConfigs$ | async"
        class="max-w-[254px]"
        [config]="linkAndConfig.config"
      >
        <vs-badge
          *ngIf="linkAndConfig.link.claimItem_1 && linkAndConfig.link.claimItem_2"
          slot="header-end"
          [theme]="
            getItemTheme(
              linkAndConfig.link.claimItemId_1 !== item.id
                ? linkAndConfig.link.claimItem_1
                : linkAndConfig.link.claimItem_2
            )
          "
        >
          {{
            (linkAndConfig.link.claimItemId_1 !== item.id
              ? linkAndConfig.link.claimItem_1.status
              : linkAndConfig.link.claimItem_2.status
            ) | titlecase
          }}
        </vs-badge>
      </vs-info-card>
    </div>

    <div *vsLet="isCustomerPortal$ | async as isCustomerPortal">
      <div
        *vsLet="canManageCoverage$ | async as canManageCoverage"
        class="flex gap-2"
        [class.justify-end]="claim?.status !== open || item.authorizationId || !canManageCoverage || item.deleted"
        [class.justify-between]="
          claim?.status === open &&
          !item.authorizationId &&
          ((customerCanEdit$ | async) || canManageCoverage) &&
          !item.deleted
        "
      >
        <button
          *ngIf="
            ((customerCanEdit$ | async) || canManageCoverage) &&
            claim?.status === open &&
            !item.authorizationId &&
            !item.deleted
          "
          vs-button
          appearance="outline"
          (click)="navigateTo('manage-details')"
        >
          Edit
        </button>

        <button vs-button theme="primary" (click)="navigateTo('cure')">Next</button>
      </div>
    </div>
  </ng-container>
</div>
